import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  searchbar: {
    display: 'flex',
    alignItems: 'center',
    color: '#81818D',
  },
  searchIcon: {
    position: 'relative',
    top: '1px',
    left: '-1px',
    width: '20px',
    color: '#81818D',
  },
  searchIconContrast: {
    color: 'white',
  },
  searchIconActive: {
    color: '#3560FF',
  },
}));
